/**
 * `orders` namespace — English canonical source.
 *
 * The order blotter (routes/orders.tsx): page chrome, the status-group filter,
 * table headers, empty/error copy, the dry-run/live and lifecycle-status badges,
 * and the BUY/SELL + order-type vocabulary. Status labels mirror the strategies
 * glossary (Filled→체결, Partial→부분 체결, Rejected→거부됨). The DRY-RUN badge is a
 * fixed token and stays "DRY-RUN" in every locale. Shared actions (Cancel) reuse
 * `common.*`. `ko/orders.ts` mirrors this shape (a missing key is a type error).
 */
export const orders = {
  // ── page chrome ──
  eyebrow: "Execution",
  title: "Orders",
  description: "Every submitted order — dry-run and live — with lifecycle status and fills.",

  // ── status-group filter ──
  filterAll: "All",
  filterOpen: "Open",
  filterClosed: "Closed",

  // ── empty / error ──
  loadError: "Could not load orders. Try again.",
  emptyTitle: "No orders yet",
  emptyDescription: "Orders placed by your strategies — simulated or live — will appear here.",

  // ── table headers ──
  colSymbol: "Symbol",
  colSide: "Side",
  colType: "Type",
  colSize: "Size",
  colPrice: "Price",
  colFilled: "Filled",
  colStatus: "Status",
  colPlaced: "Placed",
  colActions: "Actions",

  // ── row affordances ──
  loadMore: "Load more",
  decision: "Decision",

  // ── badges (DRY-RUN badge stays a fixed token; Live stays English) ──
  badgeDryRun: "Dry-run",
  badgeLive: "Live",

  // ── side / type vocabulary (enum values rendered inline) ──
  sideBuy: "BUY",
  sideSell: "SELL",
  typeMarket: "MARKET",
  typeLimit: "LIMIT",
  priceMarket: "Market",

  // ── lifecycle status (glossary-aligned) ──
  statusFilled: "Filled",
  statusPartial: "Partial",
  statusPending: "Pending",
  statusIntent: "Intent",
  statusCancelling: "Cancelling",
  statusReplacing: "Replacing",
  statusCanceled: "Canceled",
  statusReplaced: "Replaced",
  statusRejected: "Rejected",
  statusCancelRejected: "Cancel rejected",
  statusReplaceRejected: "Replace rejected",
} as const;

export type OrdersKey = keyof typeof orders;
